import { Input, Checkbox } from "@/components/Inputs";
import { name, cardsImage, applepayImage, googlepayImage, defaultTips, cartItems } from "@/constants";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Link } from "react-router-dom";

const Index = () => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("Preparing");
    const [statusSteps, setStatusSteps] = useState(["Paid", "Order created", "Preparing", "Completed"]);

    return (
        <div className="pb-6 md:pb-20 flex flex-col-reverse md:flex-row items-start padding-x">
            <section className="w-full md:w-2/3 md:mr-5">
                <h1 className="font-bold text-xl md:text-2xl lg:text-3xl">
                    Bunchiz is <span className="text-primary">preparing</span> your order.
                </h1>
                <p className="pb-4 font-light text-sm">We’ve got your order.</p>
                <div className="flex flex-col p-2 rounded-lg bg-white">
                    <div>
                        <p className="w-full p-2 pb-0">Order #000 001</p>
                        <div className="p-2 py-4">
                            <div className="flex w-full text-sm font-light">
                                <div className="flex-1 p-2 px-4 rounded-l cursor-pointer text-white bg-shade-dark">
                                    Eat in
                                </div>
                                <div className="flex-1 p-2 px-4 rounded-r cursor-pointer bg-shade">Table 1</div>
                            </div>
                        </div>
                        <div className="flex justify-between relative w-full">
                            {statusSteps.map((item, index) => {
                                const activeIndex = statusSteps.findIndex((step) => step === status);
                                return (
                                    <div
                                        className={`${
                                            activeIndex >= index ? "text-primary" : "text-shade-dark"
                                        } flex-1 flex flex-col items-center justify-between relative`}
                                    >
                                        <p>{item}</p>
                                        <div
                                            className={`${
                                                activeIndex >= index ? "bg-primary" : "bg-shade-dark"
                                            } p-[10px] relative z-10 rounded-full`}
                                        />
                                        {index !== 0 && (
                                            <div
                                                className={`${
                                                    activeIndex >= index ? "bg-primary" : "bg-shade-dark"
                                                } absolute z-0 w-full h-1 -left-1/2 bottom-2`}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="flex-1 m-2 p-2 pr-4 py-6 border-y-[1.5px] border-shade-dark h-full overflow-y-scroll">
                        {cartItems.length > 0 ? (
                            cartItems.map((item) => (
                                <div className="flex justify-between py-3" key={item.id}>
                                    <div className="flex">
                                        <div className="px-1 h-8 mr-2 flex justify-center items-center rounded-md bg-shade-light">
                                            <p className="px-1 select-none">{item.qty}</p>
                                        </div>
                                        <div className="flex flex-col">
                                            <h2 className="text-sm font-light underline">{item.productName}</h2>
                                            {item.meal ? (
                                                <>
                                                    <p className="text-xs text-gray-500 font-light">Make it A Meal</p>
                                                    <p className="text-xs text-gray-500 font-light">{item.meal}</p>
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                    <p className="text-sm font-light whitespace-nowrap">
                                        £ {(parseFloat(item.price) * item.qty).toFixed(2)}
                                    </p>
                                </div>
                            ))
                        ) : (
                            <div className="text-shade-dark text-center text-sm">Your basket is empty</div>
                        )}
                    </div>
                    <div className="p-2 text-sm font-light">
                        {/* <span className="text-gray-400 flex justify-between">
                    <p>Multibuy discount</p>
                    <p>-£{multibuy}</p>
                </span> */}
                        <span className="text-gray-400 flex justify-between">
                            <p>Subtotal</p>
                            <p>£ 12.25</p>
                        </span>
                        {/* <span className="text-gray-400 flex justify-between">
                    <p>Service charge</p>
                    <p>£{service.toFixed(2)}</p>
                </span> */}
                        <span className="text-gray-400 flex justify-between">
                            <p>Tip</p>
                            <p>£2</p>
                        </span>
                        <span className="flex justify-between">
                            <p>Total</p>
                            <p>£14.25</p>
                        </span>
                    </div>
                </div>
                <br />
                <div className="flex flex-wrap p-2 rounded-lg bg-white">
                    <p className="w-full p-2">Receipt</p>
                    <div className="flex items-center rounded border-l-4 cursor-pointer p-2 m-2 w-full border-primary bg-shade-light ">
                        <p className="text-sm font-light">Email</p>
                    </div>
                    <div className="flex w-full pr-2">
                        <Input
                            width="w-3/4"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="text"
                            placeholder="Email address"
                        />
                        <button className="w-1/4 bg-secondary text-white rounded p-3 my-2 font-semibold text-center">
                            Send
                        </button>
                    </div>
                    <div className="flex items-center rounded border-l-4 cursor-pointer p-2 m-2 w-full bg-shade-light ">
                        <p className="text-sm font-light">SMS</p>
                    </div>
                </div>
                <div className="flex flex-col">
                    <Link
                        to="order"
                        className="bg-primary hover:bg-secondary text-white rounded-lg p-2 px-6 my-4 w-full md:w-fit m-auto font-semibold text-center"
                    >
                        View my order
                    </Link>
                    <Link
                        className="text-primary hover:text-secondary rounded-lg w-fit m-auto font-semibold text-center"
                        to={"/menu"}
                    >
                        Back to menu
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Index;
